module.exports = __webpack_public_path__ + "static/DeNovo_COVID-19_Form-4fff0e2ecfb8d96788ee6f87908653ad.pdf";